import { useParams } from 'react-router-dom'

import EventDetailsContainer from '../containers/events/Details'

const EventPage = () => {
  const { id } = useParams<{ id: string }>()
  if(!id) {
    return <div>Invalid event id</div>
  }
  return <EventDetailsContainer id={parseInt(id)} />
}

export default EventPage
